import { BlockfrostApiKey } from 'crypto-sdk';

export const BLOCKFROST_API_KEYS: Readonly<BlockfrostApiKey> = {
  0: process.env.VUE_APP_BLOCKFROST_0 ?? '',
  1: process.env.VUE_APP_BLOCKFROST_1 ?? '',
};
